import { useContext, useMemo } from 'react';
import { CheckoutContext } from '@/context/CheckoutContext';
import { PaymentMethodEnum, ProviderEnum, Templates } from '@/types/common';
import { GooglePayStripeForm } from './GooglePayStripeForm';
import { GooglePayAdyenForm } from './GooglePayAdyenForm';
import { InputTaxComponent } from '../InputTaxComponent/InputTaxComponent';
import { useTranslate } from '@/hooks/useTranslate';

export const GooglePayForm = ({ isDeviceButton }: { isDeviceButton?: boolean }) => {
  const { paymentMethodsSettings, template } = useContext(CheckoutContext);
  const providerSettings = paymentMethodsSettings.find(
    (paymentMethod) => paymentMethod.paymentMethodName === PaymentMethodEnum.GOOGLE_PAY
  )!;
  const { t } = useTranslate();

  const isOnePayment = template.type === Templates.OnePayment;

  const Component = useMemo(() => {
    if (providerSettings?.provider === ProviderEnum.STRIPE) {
      return <GooglePayStripeForm />;
    }
    if (providerSettings?.provider === ProviderEnum.ADYEN) {
      return <GooglePayAdyenForm />;
    }
    return null;
  }, [providerSettings]);

  return (
    <div className="flex flex-col gap-4">
      {!isOnePayment && (
        <div className="flex flex-col gap-2 pb-4 mt-4">
          <div className="text-base text-card-foreground font-bold">{t('paymentViaGooglePay')}</div>
          <div className="text-sm text-muted-foreground">{t('googlePayRedirectMessage')}</div>
        </div>
      )}
      {Component}
      {!isDeviceButton && <InputTaxComponent />}
    </div>
  );
};
